<template>
  <div>
    <div slot="title">
      <h2>Preparar Solicitud</h2>
    </div>
    <div slot="main">
      <ul class="nav nav-tabs" id="tabAltaUsuario" role="tablist" style="display:none">
        <li class="nav-item">
          <a class="nav-link active" id="solicitud-tab" data-toggle="tab" href="#solicitud" role="tab" aria-controls="solicitud" aria-selected="true">Solicitud</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="buscador-tab" data-toggle="tab" href="#buscador" role="tab" aria-controls="buscador" aria-selected="false">Buscador de Evaluados</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="periodo-tab" data-toggle="tab" href="#periodo" role="tab" aria-controls="periodo" aria-selected="false">Asignación de Periodo</a>
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade show active" id="solicitud" role="tabpanel" aria-labelledby="solicitud-tab">
          <div class="container-fluid" style="margin-top:30px;">
            <div class="row">
              <div class="col-5">
                <h5><span class="label label-default">Agregar Personas a la Solicitud de Evaluación</span></h5>
              </div>
            </div>
            <div class="row" style="margin-top:20px;">
              <div class="col-2">
                <span class="label label-default">Evaluados Agregados : </span>
              </div>
              <div class="col-1">
                <span class="badge badge-light">{{numeroFilas}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-8"></div>
              <div class="col-2">
                <button type="button" class="form-control" @click="clickPestana('buscador-tab')">
                  <i class="fa fa-plus-square"></i><span class="label label-default" style="margin-left:5px;">Agregar Evaluado</span>
                </button>
              </div>
            </div>

            <div class="row" style="margin-top:50px;">
              <div class="col-10">
                <table class="table table-striped table-light table-hover" id="tablaSolicitudes">
                  <thead class="thead-dark">
                    <tr>
                      <th>ID Evaluado</th>
                      <th>Nombre</th>
                      <th>Puesto</th>
                      <th>Departamento</th>
                      <th>Sección</th>
                      <th>Tipo Puesto</th>
                      <th>Fecha de Entrega</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody class='text-dark'>
                    <tr v-for="infoEvaluador in infoEvaluadores">
                      <td>{{ infoEvaluador.NumeroNomina }}</td>
                      <td>{{infoEvaluador.NombreCompleto}}</td>
                      <td>{{infoEvaluador.Puesto}}</td>
                      <td>{{infoEvaluador.Departamento}}</td>
                      <td>{{infoEvaluador.Seccion}}</td>
                      <td></td>
                      <td>{{infoEvaluador.fechaLimiteFormat}}</td>
                      <td class='d-flex justify-content-around'>
                        <i class='fa fa-calendar' @click='irSeleccionPeriodo(infoEvaluador,true)' title="Seleccionar Periodo de Evaluación" />
                        <i class='fa fa-trash' @click='borrarEvaluado' title="Borrar Evaluado" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row">
              <div class="col-8"></div>
              <div class="col-2">
                <button type="button" class="form-control" @click="Finalizar" v-bind:disabled="numeroFilas <= 0">
                  <i class="fa fa-folder-plus"></i><span class="label label-default" style="margin-left:5px;">Crear Solicitud</span>
                </button>
              </div>
            </div>
          </div>

        </div>
        <div class="tab-pane fade" id="buscador" role="tabpanel" aria-labelledby="buscador-tab">
          <div class="container-fluid" style="margin-top:30px;">
            <div class="row">
              <div class="col-3">
                <button type="button" class="form-control" @click="clickPestana('solicitud-tab')">
                  <i class="fa fa-arrow-left"></i><span class="label label-default" style="margin-left:5px;">Volver</span>
                </button>
              </div>
            </div>
            <div class="row" style="margin-top:20px">
              <div class="col-5">
                <h5><span class="label label-default">Buscador de Evaluados</span></h5>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <input type="text" class="form-control" placeholder="Nombre" v-model="nombreBusqueda" v-on:keyup.enter="buscarEvaluados" />
              </div>
              <div class="col-3">
                <input type="text" class="form-control" placeholder="No. de Nómina" v-model="numeroNominaBusqueda" v-on:keyup.enter="buscarEvaluados" />
              </div>
              <div class="col-1">
                <input type="checkbox" v-model="filtroPuesto" />
              </div>
              <div class="col-2">
                <span class="label label-default">Tipo de Puesto</span>
              </div>
            </div>
            <div class="row">
              <div class="col-6"></div>
              <div class="col-3"><hr /></div>
            </div>
            <div class="row">
              <div class="col-3"></div>
              <div class="col-3">
                <div class="alert alert-danger" role="alert" data-dismiss="alert" aria-label="Close" id="alertaNumeroNomina">
                  Valor no válido
                </div>
              </div>
              <div class="col-1" v-show="filtroPuesto">
                <input type="checkbox" v-model="interinoBusqueda" />
              </div>
              <div class="col-2" v-show="filtroPuesto">
                <span class="label label-default">Interinato</span>
              </div>
            </div>
            <div class="row">
              <div class="col-6"></div>
              <div class="col-1" v-show="filtroPuesto">
                <input type="checkbox" v-model="deBaseBusqueda" />
              </div>
              <div class="col-2" v-show="filtroPuesto">
                <span class="label label-default">Base</span>
              </div>
            </div>
            <div class="row">
              <div class="col-9"></div>
              <div class="col-2"><input type="button" value="Buscar" v-on:click="buscarEvaluados" class="form-control" /></div>
            </div>
            <div class="row">
              <div class="col-12"><hr /></div>
            </div>
            <div class="row" v-show="mostrarTabla" style="margin-top:50px;">
              <div class="col-10">
                <table class="table table-striped table-light table-hover" id="tablaEvaluados">
                  <thead class="thead-dark">
                    <tr>
                      <th>ID Evaluado</th>
                      <th>Nombre</th>
                      <th>Puesto</th>
                      <th>Departamento</th>
                      <th>Sección</th>
                      <th>Tipo Puesto</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody class='text-dark'>
                    <tr v-for='infoPersona in infoPersonas'>
                      <td>{{ infoPersona.NumeroNomina }}</td>
                      <td>{{infoPersona.NombreCompleto}}</td>
                      <td>{{infoPersona.Puesto}}</td>
                      <td>{{infoPersona.Departamento}}</td>
                      <td>{{infoPersona.Seccion}}</td>
                      <td>{{infoPersona.TipoContrato}}</td>
                      <td><i class='fa fa-plus-circle' @click='insertarValor(infoPersona)' title="Agregar Evaluado" /></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row">
              <div class="col-12" id="salida">

              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="periodo" role="tabpanel" aria-labelledby="periodo-tab">
          <div class="container-fluid" style="margin-top:30px;">
            <div class="row">
              <!--<div class="col-3">
                <button type="button" class="form-control" @click="clickPestana('buscador-tab')">
                  <i class="fa fa-arrow-left"></i><span class="label label-default" style="margin-left:5px;">Volver</span>
                </button>
              </div>-->
            </div>
            <div class="row" style="margin-top:20px">
              <div class="col-5">
                <h5><span class="label label-default">Persona a Evaluar</span></h5>
              </div>
            </div>
            <div class="row" style="margin-top:30px;">
              <div class="col-3">
                <span class="label label-default">ID Evaluado</span>
              </div>
              <div class="col-3">
                <span class="label label-default">Nombre</span>
              </div>
              <div class="col-3">
                <span class="label label-default">Tipo Puesto</span>
              </div>
            </div>
            <div class="row" style="margin-top:10px;">
              <div class="col-3">
                <input type="text" class="form-control" v-model="idEvaluadoPeriodo" readonly />
              </div>
              <div class="col-3">
                <input type="text" class="form-control" value="Juan José Sánchez" v-model="nombreEvaluadoPeriodo" readonly />
              </div>
              <div class="col-3">
                <input type="text" class="form-control" value="Base" v-model="tipoPuestoPeriodo" readonly />
              </div>
            </div>
            <div class="row">
              <div class="col-12"><hr /></div>
            </div>
            <div class="row" style="margin-top:20px;">
              <div class="col-5">
                <h5><span class="label label-default">Historial Laboral</span></h5>
              </div>
            </div>
            <div class="row" style="margin-top:10px;">
              <div class="col-10">
                <table class="table table-striped table-light table-hover" id="tablaHistorial">
                  <thead class="thead-dark">
                    <tr>
                      <th></th>
                      <th>Tipo Puesto</th>
                      <th>Periodo</th>
                      <th>Departamento</th>
                      <th>Sección</th>
                      <th>Puesto</th>
                    </tr>
                  </thead>
                  <tbody class='text-dark'>
                    <tr v-for='(registro,indice) in infoHistorialLaboral'>
                      <td><input type='radio' name='periodo' @click='cargarFechas(registro.FechaInicial,registro.FechaFinal,indice+1, registro.HistoriaLaboralId, registro.Puesto)'></td>
                      <td>{{ registro.TipoContrato }}</td>
                      <td>{{registro.Periodo}}</td>
                      <td>{{registro.Departamento}}</td>
                      <td>{{registro.Seccion}}</td>
                      <td>{{registro.Puesto}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row" style="margin-top:20px;">
              <div class="col-5">
                <h5><span class="label label-default">Periodo a Evaluar</span></h5>
              </div>
            </div>
            <div class="row" style="margin-top:20px;">
              <div class="col-3">
                <span class="label label-default">Fecha Inicial:</span>
              </div>
              <div class="col-3">
                <span class="label label-default">Fecha Final:</span>
              </div>
            </div>
            <div class="row" style="margin-top:20px;">
              <div class="col-3">
                <input type="date" class="form-control" id="fechaInicial" v-model="fechaInicial" required>
              </div>
              <div class="col-3">
                <input type="date" class="form-control" id="fechaFinal" v-model="fechaFinal" required>
              </div>
            </div>
            <div class="row" style="margin-top:20px;">
              <div class="col-3">
                <span class="label label-default">Fecha Límite de Entrega:</span>
              </div>
            </div>
            <div class="row" style="margin-top:20px;">
              <div class="col-3">
                <input type="date" class="form-control" id="fechaLimite" v-model="fechaLimite" required>
              </div>
            </div>
            <div class="row" style="margin-top:20px;">
              <div class="col-6">
                <input type="button" class="form-control" value="Asignar Periodo" v-bind:disabled="deshabilitarBotonPeriodo" @click="agregarFechasTablaSolicitud">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import comun from '@/../static/js/comun'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'
  import Vue from 'vue'
  import store from '@/store/index'

  export default {
    props: {
      idSolicitud: {
        type: Number,
        default: 0
      }
    },//Recibe el id de Solicitud a editar
    data() {
      return {
        filtroPuesto: false,//Indica si el filtro de tipo de contrato está activo para la busqueda de evaluados
        mostrarTabla: false,//Indica si la tabla de busqueda de evaluados es visible
        nombreBusqueda: "", //Filtro de busqueda de nombre para evaluados
        numeroNominaBusqueda: "", //Filtro de busquedad de número de nómina para evaluados
        interinoBusqueda: false, //Filtro de busqueda para personal interino para evaluados
        deBaseBusqueda: false, //Filtro de busqueda para personal de base para evaluados
        idEvaluadoPeriodo: null,//Indica el id del evaluado al cual se le está asignando un periodo de evaluación
        nombreEvaluadoPeriodo: null,//Indica el nombre del evaluado al cual se le está asignando un periodo de evaluación
        tipoPuestoPeriodo: null,//Indica el tipo de contrato del evaluado al cual se le está asignando un periodo de evaluación
        fechaInicial: null,//Almacena la fecha inicial del periodo de evaluación del evaluado
        fechaFinal: null,//Almacena la fecha final del periodo de evaluación del evaluado
        fechaLimite: null,//Almacena la fecha limite de evaluación del evaluado
        idHistorialLaboral: null,
        numeroFilas: 0,//Almacena el número de evaluados asignados a la solicitud
        estadoSolicitud: 1, //Indica el status con el cual será modificada la evaluación
        indice: 0,//Indica el indice del periodo seleccionado para evaluación
        infoPersonas: [],
        infoHistorialLaboral: [],
        infoEvaluadores: [],
        puestoTemporal: ""
      }
    },
    components: {
      //Layout
    },
    methods: {
      ///busca a traves de axios los posibles evaluados almacenados en base de datos
      buscarEvaluados: function (event) {
        if (isNaN(this.numeroNominaBusqueda)) {
          $('#alertaNumeroNomina').show();
          return
        }
        var peticion = {
          //Carga los datos para hacer la petición
          "esPrueba": false,
          "nombreBusqueda": this.nombreBusqueda,
          "numeroNominaBusqueda": parseInt(this.numeroNominaBusqueda, 10),
          "tipoPuestoBusqueda": this.filtroPuesto,
          "interinoBusqueda": this.interinoBusqueda,
          "deBaseBusqueda": this.deBaseBusqueda,
          "baneados": []
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIAP.funcion.GetPersonas, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            $("#alertaNumeroNomina").hide();
            this.infoPersonas = response.data.InfoPersonas//Carga los valores necesarios
            this.mostrarTabla = true
            this.$nextTick(() => {
              PaginarTabla('tablaEvaluados', 10)
            })
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      }, borrarFila: function (event) {//Elimina una fila de una tabla
        var boton = event.target
        var row = boton.parentElement.parentElement;
        if (row.tagName == "TR") {
          row.remove();
        }
      }, insertarValor: function (infoPersona) {//Accion ejecutada al agregar un evaluado a la solicitud

        var duplicado = this.verificarDuplicado(infoPersona)
        this.irSeleccionPeriodo(infoPersona, duplicado)//Da paso a la sección de selección de periodo de evaluación
        if (!duplicado) {
          this.agregarEvaluado(infoPersona, null, null, null)//En caso de que el evaluado no se haya agregado previamente, lo agrega a la tabla de evaluados asignados
        }
      }, verificarDuplicado: function (infoPersona) {//Verifica que la persona agregada no se haya agregado previamente a evaluados asignados
        var bandera = false;
        this.infoEvaluadores.forEach(function (evaluacion) {//Recorre la lista de evaluados asignados
          if (evaluacion.PersonaId == infoPersona.PersonaId) {//en caso de que haya una coincidencia cambia el estado de bandera
            bandera = true;
            return
          }
        });
        return bandera;
      }, agregarEvaluado: function (infoPersona, fechaInicio, fechaFin, fechaLimite) {///Agregar un evaluado a la lista de evaluados asignaods
        var fechaLimiteFormat = (fechaLimite != null) ? moment(fechaLimite, 'YYYY-MM-DD').format('DD/MM/YYYY') : "N/A";
        //Añade la información de la nueva evaluación al listado de evaluaciones agregados
        this.infoEvaluadores.push({
          PersonaId: infoPersona.PersonaId, NombreCompleto: infoPersona.NombreCompleto, Puesto: infoPersona.Puesto, Departamento: infoPersona.Departamento, Seccion: infoPersona.Seccion,
          fechaLimiteFormat: fechaLimiteFormat, FechaInicioPeriodoEvaluacion: fechaInicio, FechaFinPeriodoEvaluacion: fechaFin, FechaLimiteEntrega: fechaLimite
        })
        this.$nextTick(() => {
          PaginarTabla('tablaSolicitudes', 5)
        })
        this.numeroFilas++//Incrementa la cuenta de evaluados
      }, irSeleccionPeriodo: function (infoPersona, repetido) {
        this.setFechas(infoPersona.PersonaId, repetido)
        this.idEvaluadoPeriodo = infoPersona.PersonaId
        this.nombreEvaluadoPeriodo = infoPersona.NombreCompleto
        this.tipoPuestoPeriodo = infoPersona.TipoContrato//Carga la información para la pantalla de selección de periodo de evaluación
        $('#periodo-tab').trigger('click')//Muestra la sección de selección de periodo
        this.mostrarHistorialLaboral()//Despliega el historial laboral del evaluado
      }, setFechas: function (PersonaId, duplicado) {
        var fechaIni = null
        var fechaFin = null
        var fechaLim = null
        if (duplicado) {//Verifica si el evaluado es duplicado
          this.infoEvaluadores.forEach(function (evaluacion) {
            if (evaluacion.PersonaId == PersonaId) {//itera a través de los evaluados asignados
              fechaIni = evaluacion.FechaInicioPeriodoEvaluacion
              fechaFin = evaluacion.FechaFinPeriodoEvaluacion
              fechaLim = evaluacion.FechaLimiteEntrega//En caso de encontrarlo extrae las fechas del evaluado
              return
            }
          });
        }
        this.fechaInicial = fechaIni
        this.fechaFinal = fechaFin
        this.fechaLimite = fechaLim//Inserta las fechas a la sección de selección de periodo
      }, verificarEvaluaciones: function () {//Verifica si todos los evaluados cuentan con sus fechas completas
        var bandera = true;
        this.infoEvaluadores.forEach(function (evaluacion) {//Itera a través de la lista de evaluados
          if (evaluacion.FechaInicioPeriodoEvaluacion == null) {//En caso de encontrar una fecha vacia, cambia el valor de bandera
            bandera = false;
          }
        })
        this.estadoSolicitud = (bandera) ? 2 : 1 //En base al valor de bandera modifica el nuevo estado de la solicitud
      }
      , mostrarHistorialLaboral: function () {//Muestra el historial laboral del evaluado
        this.indice = 0

        var peticion = {
          //Carga la información para la petición
          "esPrueba": false,
          "IdPersona": this.idEvaluadoPeriodo
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIAP.funcion.GetHistorialLaboral2, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            this.infoHistorialLaboral = response.data.InfoHistorialLaboral
            
            this.$nextTick(() => {
              if (this.infoHistorialLaboral.length > 0) {
              document.getElementsByName("periodo")[0].checked = true;
              this.cargarFechas(this.infoHistorialLaboral[0].FechaInicial, this.infoHistorialLaboral[0].FechaFinal, 1, this.infoHistorialLaboral[0].HistoriaLaboralId,"");
            } else {
              this.idHistorialLaboral = null;
              document.querySelector('input[name="periodo"]:checked').checked = false;
            }
              PaginarTabla('tablaHistorial', 3)
            })

            this.$forceUpdate();
            
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      }, cargarFechas: function (fechaInicial, fechaFinal, indice, idHistorialLaboral, puesto) {//Inserta las fechas inicial y final en la sección de asignación de periodo de evaluación al momento de seleccionar un periodo laboral
        this.puestoTemporal = puesto
        this.idHistorialLaboral = idHistorialLaboral
        this.fechaInicial = fechaInicial
        if (moment(fechaFinal, "YYYY-MM-DD", true).isValid()) {//Verifica que la fecha final sea valida antes de insertarla
          this.fechaFinal = fechaFinal
        }
        this.indice = indice//Actualiza el valor del indice de periodo laboral
      }, agregarFechasTablaSolicitud: function () {//Inserta las fechas de evaluación a la tabla de solicitud
        var idEvaluado = this.idEvaluadoPeriodo
        var fechaLimite = this.fechaLimite
        var fechaInicial = this.fechaInicial
        var fechaFinal = this.fechaFinal
        var infoEvaluadores = this.infoEvaluadores
        var idHistorialLaboral = this.idHistorialLaboral
        var puestoTemporal = this.puestoTemporal;
        var id = 0
        $.each(infoEvaluadores, function (rowIndex, r) { //Itera a través de la tabla de solicitud
          id = r.PersonaId
          if (id == idEvaluado) {//En caso de encontrar una coincidencia entre la evaluación a modificar y un registro de la tabla se agregan las fechas a la tabla y al listado de evaluados agregados
            infoEvaluadores[rowIndex].fechaLimiteFormat = moment(fechaLimite, 'YYYY-MM-DD').format("DD/MM/YYYY")
            infoEvaluadores[rowIndex].FechaInicioPeriodoEvaluacion = fechaInicial
            infoEvaluadores[rowIndex].FechaFinPeriodoEvaluacion = fechaFinal
            infoEvaluadores[rowIndex].FechaLimiteEntrega = fechaLimite
            infoEvaluadores[rowIndex].idHistorialLaboral = idHistorialLaboral
            infoEvaluadores[rowIndex].Puesto = puestoTemporal;

          }
        });

        this.infoEvaluadores = infoEvaluadores
        this.$nextTick(() => {
          PaginarTabla('tablaSolicitudes', 5)
        })
        $('#solicitud-tab').trigger('click')//Se muestra la sección de evaluados agregados
        //this.verificarEvaluaciones()
      }, Finalizar: function () {
        if (this.idSolicitud == 0) {
          this.crearSolicitud()
        }
      }, crearSolicitud: function () {
        this.verificarEvaluaciones()
        var peticion = {
          "Activo": true,
          "UsuarioCreacionId": 1,
          "EstatusSolicitudId": this.estadoSolicitud,
          "Evaluaciones": this.getEvaluaciones()
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIAP.funcion.CrearSolicitud, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            this.$router.push("/SIAP/SolicitudesEvaluacion")
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
            // this.error = response.data.Error.Mensaje;
            // $('#modalInvalidezAlerta').modal('show');
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      }, actualizarSolicitud: function () {//Se hace la escritura en base de datos de la edición de la solicitud
        this.verificarEvaluaciones()
        //Se cargan los datos para hacer la petición
        var peticion = {
          "idSolicitud": this.idSolicitud,
          "Activo": true,
          "EstatusSolicitudId": this.estadoSolicitud,
          "Evaluaciones": this.getEvaluaciones()
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIAP.funcion.ActualizarSolicitud, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //En caso de quela actualización sea exitosa se redirige a la pagina SIAP/SolicitudesEvaluacion
            this.$router.push("/SIAP/SolicitudesEvaluacion")
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      }, borrarEvaluado(event) {//borra un evaluado de la tabla y el listado de evalados asignados
        var fila = event.target.parentElement.parentElement
        var indice = $("#tablaSolicitudes tbody tr").index(fila)//Se obtiene el indice del evaluado a eliminar
        if (indice >= 0) {
          this.$delete(this.infoEvaluadores, indice)
          this.$nextTick(() => {
            PaginarTabla('tablaSolicitudes', 5)
          })
          //this.borrarFila(event)
          this.numeroFilas--//Se disminuye el número de evaluados asignados
        }
      },
      clickPestana: function (identificador) {//Simula el click sobre una pestaña
        $('#' + identificador).trigger('click')
      }, cargarInfo: function (idSolicitud) {//Extrae la información sobre una solicitud de evaluaciones
        //Carga los datos para hacer la petición
        var peticion = {
          "esPrueba": false,
          "IdSolicitud": idSolicitud
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SISEVA.funcion.GetSolicitud, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //En caso de ser uná consulta exitosa inserta los datos obtenidos en la vista
            var agregarEvaluado = this.agregarEvaluado
            var listaEvaluaciones = response.data.SolicitudEvaluacion.evaluaciones
            var infoPersona = null
            var fechaInicio = null
            var fechaFin = null
            var fechaLimite = null
            listaEvaluaciones.forEach(function (evaluacion) {//Itera a través de las evaluaciones obtenidas de la consulta
              infoPersona = { PersonaId: 0, NombreCompleto: "", Puesto: "", Departamento: "", Seccion: "", TipoContrato: "" }//construye un objeto infoPersona
              infoPersona.PersonaId = evaluacion.EvaluadoId
              infoPersona.NombreCompleto = evaluacion.nombreEvaluado
              infoPersona.Puesto = evaluacion.Puesto
              infoPersona.Departamento = evaluacion.Departamento
              infoPersona.Seccion = evaluacion.Seccion
              infoPersona.TipoContrato = evaluacion.TipoContrato//carga la información de la evaluación dentro de infoPersona
              fechaInicio = (evaluacion.FechaInicioPeriodoEvaluacion != null) ? evaluacion.FechaInicioPeriodoEvaluacion.substring(0, 10) : null
              fechaFin = (evaluacion.FechaFinPeriodoEvaluacion != null) ? evaluacion.FechaFinPeriodoEvaluacion.substring(0, 10) : null
              fechaLimite = (evaluacion.FechaLimiteEntrega != null) ? evaluacion.FechaLimiteEntrega.substring(0, 10) : null //carga las fechas de la evaluación
              agregarEvaluado(infoPersona, fechaInicio, fechaFin, fechaLimite)//Inserta al evaluado
            });
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      getEvaluaciones: function () {
        var evaluaciones = []
        var infoEvaluadores = this.infoEvaluadores
        infoEvaluadores.forEach(function (evaluacion) {
          evaluaciones.push({
            EvaluadoId: evaluacion.PersonaId, FechaInicioPeriodoEvaluacion: evaluacion.FechaInicioPeriodoEvaluacion, FechaFinPeriodoEvaluacion: evaluacion.FechaFinPeriodoEvaluacion,
            FechaLimiteEntrega: evaluacion.FechaLimiteEntrega, esPrueba: false, HistorialLaboralId: evaluacion.idHistorialLaboral
          })
        })
        return evaluaciones
      }

    }, computed: { // Indica si el boton de asignar periodo deberia estar deshabilitado en base a si las fechas están capturadas y se ha seleccionado un periodo laboral
      deshabilitarBotonPeriodo: function () {
        return this.fechaInicial == null || this.fechaFinal == null || this.fechaLimite == null
      }
    }
    , mounted: function () {
      $("#alertaNumeroNomina").hide();//Oculta el mensaje de error en el número de nómina (busqueda)
      if (this.IdSolicitud != null) {
        this.cargarInfo(this.idSolicitud)//carga la información de la solicitud de evaluaciones
      }
    }

  }
</script>

<style scoped>
  a {
    color: #fff;
  }

  input[type="text"]:read-only {
    background: #504f54;
  }

  input[type="text"]:read-only:focus {
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/SIAP/Evaluaciones/NuevaSolicitud.vue